import React from "react"
import TableRow from "material-ui/Table/TableRow"
import TableRowColumn from "material-ui/Table/TableRowColumn"
import * as timeHelper from "../../helpers/timeHelper"
import { ITimecardDay } from "../../models"
interface IProps {
    timecardDays: ITimecardDay[]
}

const EquipmentTimecardTotalsRow: React.SFC<IProps> = (props: IProps) => {
    return (
        <TableRow>
            {props.timecardDays.map((timecardDay, i) =>
                <TableRowColumn key={i}>
                    <table style={{ width: "100%", paddingTop: 10, paddingBottom: 10, color: "#888888" }}>
                        <tbody>
                            <tr>
                                <td>Total:</td>
                                <td>{timeHelper.convertToHour(timecardDay.TotalProductiveInMinutes)} hrs</td>
                            </tr>
                        </tbody>
                    </table>
                </TableRowColumn>
            )}
        </TableRow>
    )
}

export default EquipmentTimecardTotalsRow
